<template>

    <div class="sidebar">

        <div v-if="component === null && componentData === null" class="full-height">

            <div id="canvas-objects-list">

                <h3>{{ currentActive.title }}</h3>

                <p><b>Beschreibung:</b> {{ currentActive.description }}</p>

                <label class="configure-property">
                    <span><input v-model="currentActive.canvas._canAddElements" type="checkbox"> Elemente hinzufügen</span>
                </label>

                <label class="configure-property">
                    <span><input v-model="currentActive.canvas._canSortElements" type="checkbox"> Elemente sortieren</span>
                </label>

                <p><b class="display-block">Daten:</b> Druckfläche: {{ currentActive.printArea }}<br> Druckverfahren: {{ currentActive.printType }}</p>

                <h4>Druckelemente:</h4>

                <CanvasObject v-for="(item, index) in objectsFromCurrentActive" @levelPlus="levelPlus" @levelMinus="levelMinus" :canvas-object="item" :canvas-objects-length="canvasObjectsLength" @showCanvasObjectView="showCanvasObjectView"></CanvasObject>

                <div class="option-button" style="margin-top: 30px">
                    <div class="select" style="margin-bottom: 5px;">

                        <select v-model="newElementType">
                            <option disabled value="null">Typ wählen</option>
                            <option v-for="objectType in objectTypes" :value="objectType.class">{{objectType.name}} hinzufügen</option>
                        </select>

                    </div>

                    <a :disabled="newElementType === null" class="btn" @click="addNewElement">Element hinzufügen</a>
                </div>

            </div>

            <div class="option-button">
                <a v-if="!load" class="btn btn-fullsize" @click="clickedSaveButton">Vorlage speichern</a>
                <a v-if="load" class="btn btn-fullsize">

                    <img src="img/loader.gif" alt="">

                </a>
            </div>

        </div>

        <div v-if="component !== null && componentData !== null" class="full-height">

            <div id="customize-selected" >

                <component :is="component" :data="componentData"></component>

            </div>

            <div class="option-button">
                <a class="btn btn-red btn-fullsize" @click="deleteCanvasObject">Element löschen</a>
            </div>

            <div class="option-button" style="margin-top: 10px">
                <a class="btn btn-fullsize" @click="closeCanvasObjectView">Zurück</a>
            </div>

        </div>


    </div>



</template>

<script>
    import CanvasObject from "./CanvasObject";
    import TextObject from "./../structures/canvas-objects/TextObject";
    import ImageObject from "./../structures/canvas-objects/ImageObject";
    import CanvasObjectsList from "./CanvasObjectsList";
    import requestHelper from "../api/requestHelper";

    export default {
        extends: CanvasObjectsList,
        name: "AdminCanvasObjectsList",
        components: {
          CanvasObject
        },
        props: {
            currentActive: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            newElementType: null,
            newImage: null,
            component: null,
            componentData: null,
            load: false,
            objectTypes: []
        }),
        computed: {

            objectsFromCurrentActive() {
                return this.currentActive.canvas.getCanvasObjects().slice().reverse();
            },
            canvasObjectsLength() {
                return this.currentActive.canvas.getNumberOfCanvasObjects();
            },


        },
        methods: {

            clickedSaveButton() {
                console.log('Vorlage speichern');
                this.load = true;
                this.$emit('save');
            },
            async showCanvasObjectView({data}) {

                data.getCanvas().getCanvas().discardActiveObject();
                data.getCanvas().setLastSelectedObjects([data.getId()]);
                data.getCanvas().render();
                this.componentData = data;
                this.component = await this.loadComponent( `Admin${data.getViewInObjectsConfigurator()}` );

            },
            async mounted() {
                window.EventHandler.$on(
                    'clearobjectview',
                    () => this.closeCanvasObjectView()
                );

                window.EventHandler.$on(
                    'savefinished',
                    () => this.load = false
                );

                this.objectTypes = await requestHelper.requestApiRoute('get', '/objecttype');
            }

        },
        mounted() {

            this.mounted();

        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    .configure-property {
        display: block;
    }

    #customize-selected, #canvas-objects-list {
        flex-grow: 1;
        flex-shrink: 1;
        overflow: auto;
    }

    h3 {
        color: $blue-color;
        margin: 0;
        font-size: 1.3rem;
    }

    h4 {
        color: $blue-color;
        margin: 40px 0 5px 0;
    }

    p {
        color: $grey-font;
        font-size: 0.9em;

        b.display-block {
            display: block;
        }
    }

    .full-height {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        box-sizing: border-box;
        background-color: $blue-color;
        color: #ffffff;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 5px;

        &.btn-red {
            background-color: #D85846;
        }

        &[disabled=disabled] {
            background-color: darken($grey-font, 20);
            cursor: default;
        }

        &:hover {
            cursor: pointer;
        }
    }

    .btn-fullsize {
        height: 100%;
        width: 100%;
    }

    .select {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid $grey-font;
        border-radius: 5px;
        position: relative;
        background-color: #ffffff;

        select {
            font-size: 0.8rem;
            border-radius: 5px;
            margin: 0;
            padding: 0.6rem 2rem 0.6rem 0.4rem;
            border: 0;
            box-sizing: border-box;
            width: 100%;
            -webkit-appearance: none;
            -moz-appearance: none;

            &::-ms-expand {
                display: none;
            }

            &:hover {
                cursor: pointer;
            }
        }

        &::after {
            position: absolute;
            font-family: "Material Icons";
            content: "arrow_drop_down";
            top: 50%;
            margin-top: -.5rem;
            right: .5rem;
            width: 1rem;
            height: 1rem;
            color: $blue-color;
            font-size: 1rem;
        }
    }

</style>
